import { c as _c } from "react/compiler-runtime";
import { ChatBubbleLeftRightSolid, Train } from '@byway/icons';
import clsx from 'clsx';
import { Button } from '~/components/Button';
import { Stack } from '~/components/Layout/Stack';
import type { JourneyTransformed } from '~/types/Journey.types';
import { PlaygroundGenerateTripsButton } from '../PlaygroundGenerateTripsButton/PlaygroundGenerateTripsButton';
import styles from './BottomBar.module.css';
function ContactLink() {
  const $ = _c(1);
  const openHelpWidget = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button onPress={openHelpWidget} variant="asLink" data-ua-click="contact_module_bottombar"><Stack space="--by-space-100" variant="horizontal"><ChatBubbleLeftRightSolid size="large" decorative={true} /><span>Contact us</span></Stack></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  window.dispatchEvent(new Event("openHelpWidget"));
}
function BuildBottomBar() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={clsx(styles.ctaContainer)}><ContactLink /><PlaygroundGenerateTripsButton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
type ReviewBottomBarProps = {
  trips: JourneyTransformed[];
};
function ReviewBottomBar(props) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = clsx(styles.ctaContainer, styles.noButtonContainer);
    t1 = <ContactLink />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Train size="large" decorative={true} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${props.trips.length} trip option${props.trips.length !== 1 ? "s" : ""}`;
  let t4;
  if ($[3] !== t3) {
    t4 = <div className={t0}>{t1}<div className={styles.infoBar}>{t2}<p>{t3}</p></div></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { BuildBottomBar, ReviewBottomBar };